import { render, staticRenderFns } from "./QAAiRun.vue?vue&type=template&id=44540fd2"
import script from "./QAAiRun.vue?vue&type=script&lang=js"
export * from "./QAAiRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports